export enum EOverlaySelectionType {
  POINTER = 'POINTER',
  ROI = 'ROI',
  POI = 'POI',
  SCRIBBLE = 'Scribble',
  ANNOTATION = 'Annotation',
  RULER = 'Ruler',
  CRYSTAL = 'Crystal',
}
